import { AutoCoderImportBatch } from '../../../types/gotypes'
import { receiptIsRetryable } from '../../../hooks/useJobReceipts'
import { isImportRequest, type ImportBatchOutcome } from '../../../utils/importBatches'

/**
 * Retry replays a receipt's stored request as a NEW receipt. It is offered on
 * the two readings that mean "this fetch is not going to produce anything more"
 * — failed, and unfinalized long enough to have stopped believing in it — and
 * never on one still legitimately running, where it would buy a second live
 * fetch of the same window. Only apify and carbon receipts record a replayable
 * request; a CSV receipt names a file the server no longer holds.
 */
export const receiptCanRetry = (batch: AutoCoderImportBatch, outcome: ImportBatchOutcome): boolean =>
  (outcome === 'failed' || outcome === 'stalled') && receiptIsRetryable(batch)

/** A request on the queue is retried when it failed and cancelled while it waits. */
export const requestAction = (batch: AutoCoderImportBatch, outcome: ImportBatchOutcome): 'retry' | 'cancel' | null => {
  if (!isImportRequest(batch)) return null
  if (outcome === 'failed') return 'retry'
  if (outcome === 'queued' || outcome === 'scheduled') return 'cancel'
  return null
}
